


  const swatchItemsforInventoryChange = document.querySelectorAll('.t4s-swatch__item');

  swatchItemsforInventoryChange.forEach(item => {
    item.addEventListener('click', function(event) {
      setTimeout(() => {
        const visibleAvailabilityItem = Array.from(document.querySelectorAll('.dataCoverForBanner')).find(
          el => window.getComputedStyle(el).display !== 'none'
        )
        
        if (visibleAvailabilityItem) {
          const availability = visibleAvailabilityItem.querySelector('[data-availability]').getAttribute('data-availability')
          document.getElementById("data-availability-property").value = availability
        }
      }, 100)
    })
  })

jQuery_T4NT(document).ready(function($) {
     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});